import { ApiCallState } from "../Utils";
import { FixedAssetRegistry } from "../FixedAssetRegistry/FixedAssetRegistry.type";

export const FixedAssetRegistryStartingBalanceActionTypes = {
  FETCH_ALL_FIXED_ASSET_REGISTRY_STARTING_BALANCE:
    "FETCH_ALL_FIXED_ASSET_REGISTRY_STARTING_BALANCE",
  FETCH_ALL_FIXED_ASSET_REGISTRY_STARTING_BALANCE_SUCCESS:
    "FETCH_ALL_FIXED_ASSET_REGISTRY_STARTING_BALANCE_SUCCESS",
  FETCH_ALL_FIXED_ASSET_REGISTRY_STARTING_BALANCE_FAILURE:
    "FETCH_ALL_FIXED_ASSET_REGISTRY_STARTING_BALANCE_FAILURE",
  FETCH_ALL_FIXED_ASSET_REGISTRY_STARTING_BALANCE_RESET:
    "FETCH_ALL_FIXED_ASSET_REGISTRY_STARTING_BALANCE_RESET",

  BULK_UPSERT_FIXED_ASSET_REGISTRY_STARTING_BALANCE:
    "BULK_UPSERT_FIXED_ASSET_REGISTRY_STARTING_BALANCE",
  BULK_UPSERT_FIXED_ASSET_REGISTRY_STARTING_BALANCE_SUCCESS:
    "BULK_UPSERT_FIXED_ASSET_REGISTRY_STARTING_BALANCE_SUCCESS",
  BULK_UPSERT_FIXED_ASSET_REGISTRY_STARTING_BALANCE_FAILURE:
    "BULK_UPSERT_FIXED_ASSET_REGISTRY_STARTING_BALANCE_FAILURE",
  BULK_UPSERT_FIXED_ASSET_REGISTRY_STARTING_BALANCE_RESET:
    "BULK_UPSERT_FIXED_ASSET_REGISTRY_STARTING_BALANCE_RESET",
};

export type LocationType = "project" | "store" | "department";

export type FixedAssetRegistryStartingBalance = {
  id?: number;
  user_id?: number;
  fixed_asset_registry_id: number;
  location_type: LocationType;
  location_id: number;
  date: string;
  starting_balance: number | null;
  fixed_asset_registry?: FixedAssetRegistry;
  createdAt?: string;
  updatedAt?: string;
};

export type FixedAssetRegistryStartingBalanceStateTypes = {
  fetchAll: ApiCallState<FixedAssetRegistryStartingBalance[]>;
  bulkUpsert: ApiCallState<any>;
};
